<template>
  <div>
    <b-card :title="fullName" style="height:100vh">
      <b-row>
        <b-cols cols="4">
          <b-img
            v-bind="contact.imgURL ? mainProps : mainPropsBlank"
            :src="`${assetsUrlHome}${contact.imgURL}`"
            rounded
            alt="Rounded image"
          />
        </b-cols>
        <b-col cols="8">
          <b-card-text>
            {{ contact.phone }}
          </b-card-text>
          <b-card-text>
            {{ contact.email }}
          </b-card-text>
        </b-col>
      </b-row>
      <hr />
      <b-row v-if="contact.address">
        <b-card-text>
          <b-card-text>
            {{ contact.address.address1 }}
          </b-card-text>
          <b-card-text>
            {{ contact.address.address2 }}
          </b-card-text>
          <b-card-text>
            {{ contact.address.city }}, {{ contact.address.state }}
            {{ contact.address.zip }}
          </b-card-text>
        </b-card-text>
      </b-row>
      <b-row v-if="createdBy">
        <b-col cols="4">
          <b-img
            v-bind="createdBy.imgURL ? imgCBProps : imgCBPropsBlank"
            :src="`${assetsUrlHome}${createdBy.imgURL}`"
            rounded
            alt="Rounded image"
          />
        </b-col>
        <b-col cols="8">
          <b-card-text>
            {{ createdBy.name }}
          </b-card-text>
          <b-card-text>
            {{ createdBy._created_at }}
          </b-card-text>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "CallLog_ContactsCardView",
  components: {
    TipTapOutput
  },
  props: {
    resource: {
      type: Object,
      required: true
    },
    contact: {
      type: Object,
      required: true
    }
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    }),
    fullName() {
      return `${this.contact.firstname} ${this.contact.lastname}`;
    },
    createdBy() {
      return this.contact._created_by;
    }
  },
  methods: {
    handleItemClick(item) {
      this.$emit("item-clicked", item);
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.$emit("close-clicked");
    },
    handleShowPlayList() {
      this.handleOpenSideBar();
    }
  },
  data() {
    return {
      sidebarId: "playlist-sidebar",
      sidebarModel: false,
      assetsUrlHome: "",
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      mainPropsBlank: {
        blank: true,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      imgCBProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      imgCBPropsBlank: {
        //Possibly a better way to do this
        blank: true,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
